import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OrganisationTree } from '../models/organisation-tree';

@Injectable({
  providedIn: 'root'
})
export class UserOrganisationsService {
  urlPath = 'organisation/user';

  constructor(private http: HttpClient) { }

  getUserOrganisations(): Observable<OrganisationTree> {
    let url = environment.launchpadApi + this.urlPath;
    return this.http.get<OrganisationTree>(url);
  }
}
